import { ComponentPortal } from '@angular/cdk/portal';
import { CustomOverlayRef } from './custom-overlay.ref';
import { Injectable, Injector, TemplateRef, Type, inject } from '@angular/core';
import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { SpinnerComponent } from '../components/spinner/spinner/spinner.component';

@Injectable({
  providedIn: 'root',
})
export class OverlayService {
  private readonly overlay = inject(Overlay);
  private readonly injector = inject(Injector);
  private overlayRef: OverlayRef | undefined;

  public show<R = unknown, T = unknown>(content?: string | TemplateRef<unknown> | Type<unknown>, data?: T): void {
    const configs = new OverlayConfig({
      positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
      hasBackdrop: true,
    });

    this.overlayRef = this.overlay.create(configs);
    const resolvedContent = content ?? '';
    const customOverlayRef = new CustomOverlayRef<R, T>(this.overlayRef, resolvedContent, data);
    const injector = this.createInjector(customOverlayRef);

    this.overlayRef.attach(new ComponentPortal(SpinnerComponent, null, injector));
  }

  public hide(): void {
    this.overlayRef?.detach();
    this.overlayRef = undefined;
  }

  private createInjector<R, T>(ref: CustomOverlayRef<R, T>): Injector {
    return Injector.create({
      parent: this.injector,
      providers: [{ provide: CustomOverlayRef, useValue: ref }],
    });
  }
}
